export default {
  nav: {
    home: "Startseite",
    categories: "Kategorien",
    article: "Leitfaden",
    ctaMain: "Hauptseite",
    ctaSpreadsheet: "CSSBuy Spreadsheet",
  },
  hero: {
    eyebrow: "CSSBuy Spreadsheet • Recherche • QC • Versand",
    title: "CSSBuy Spreadsheet: Produkte einfach finden, vergleichen und recherchieren",
    description: "Entdecken Sie ein organisiertes CSSBuy Spreadsheet mit Produktleitfäden, Kategorien, QC-Informationen, Versandhinweisen, Lagerdetails, Bewertungen und praktischen Tipps für die Recherche vor dem Kauf.",
    ctaPrimary: "CSSBuy Spreadsheet erkunden",
    ctaSecondary: "Einsteiger-Leitfaden starten",
    trust: "Unabhängige Ressource • Aktualisierter Inhalt • Mehrsprachige Leitfäden • Sicherheitsfokus",
    searchPlaceholder: "Im CSSBuy Spreadsheet suchen...",
  },
  categories: {
    title: "CSSBuy Spreadsheet nach Kategorie erkunden",
    dropdownLabel: "Kategorie auswählen",
    shoes: "Schuhe",
    hoodies: "Hoodies/Pullover",
    tshirts: "T-Shirts",
    jackets: "Jacken",
    pants: "Hosen/Shorts",
    headwear: "Kopfbedeckungen",
    sets: "Sets",
    underwear: "Unterwäsche",
    jersey: "Trikots",
    accessories: "Accessoires",
    bags: "Taschen",
    belts: "Gürtel",
    perfumes: "Parfüms",
    other: "Sonstiges",
  },
  cta: {
    title: "Bereit, Ihre Recherche zu starten?",
    description: "Verwenden Sie das CSSBuy Spreadsheet als Ausgangspunkt, um Kategorien zu entdecken, Informationen zu vergleichen und zu lernen, wie Sie Produkte, QC, Lager und Versand bewerten, bevor Sie fortfahren.",
    button1: "CSSBuy Spreadsheet erkunden",
    button2: "Hauptseite besuchen",
    buttonBuy: "Jetzt kaufen",
  },
  article: {
    title: "Vollständiger Leitfaden für CSSBuy Spreadsheet",
    description: "Lernen Sie, wie Sie das CSSBuy Spreadsheet für Produktrecherche, Kategorienavigation und Qualitätskontrolle vor dem Kauf verwenden.",
    readMore: "Vollständigen Leitfaden lesen",
  },
  footer: {
    disclaimer: "Diese Website ist eine unabhängige Informationsressource und nicht die offizielle CSSBuy-Website.",
    copyright: "© 2026 cssbuybr.fun. Alle Rechte vorbehalten.",
  },
  language: "Sprache",
  articlePage: {
    title: "Vollständiger CSSBuy Spreadsheet Leitfaden: Produkte 2026 intelligenter recherchieren",
    metaDescription: "Ein umfassender Leitfaden zur Verwendung von CSSBuy Spreadsheet für Produktrecherche, Kategorienavigation und QC-Prüfung. Unabhängige Ressource für 2026.",
    breadcrumb: "Startseite / Leitfaden",
    published: "Veröffentlicht: 15. Januar 2026",
    updated: "Zuletzt aktualisiert: 1. September 2026",
    backToHome: "← Zurück zur Startseite",
    sections: {
      intro: {
        title: "Was ist CSSBuy Spreadsheet?",
        content: "CSSBuy Spreadsheet ist eine strukturierte Ressource, die Käufern hilft, Produktlinks, Kategorien, Preise und Recherchenotizen an einem Ort zu organisieren. Anstatt in mehreren Plattformen zu suchen und verstreute Links zu speichern, können Sie eine Tabelle verwenden, um Artikel nach Kategorie zu verfolgen, Optionen zu vergleichen und Details vor einer Kaufentscheidung zu verifizieren. Dieser Leitfaden erklärt, wie Sie CSSBuy Spreadsheet 2026 effektiv für die Produktrecherche nutzen.",
      },
      research: {
        title: "Wie man Produkte mit CSSBuy Spreadsheet recherchiert",
        content: "Effektive Produktrecherche beginnt mit der Organisation Ihrer Suche. Verwenden Sie CSSBuy Spreadsheet, indem Sie zunächst eine Kategorie auswählen, die zu Ihrem gesuchten Artikel passt. Durchsuchen Sie verfügbare Artikel, vergleichen Sie Preise über verschiedene Quellen und prüfen Sie Produktdetails sorgfältig. Achten Sie auf Größentabellen, Materialbeschreibungen und Verkäuferinformationen. Überprüfen Sie immer den aktuellen Preis und die Verfügbarkeit, bevor Sie fortfahren, da Tabelleninformationen sich im Laufe der Zeit ändern können.",
      },
      categories: {
        title: "Kategorien zur besseren Organisation verwenden",
        content: "Kategorien helfen, große Produktkollektionen effizient zu durchsuchen. Ob Sie nach Schuhen, Hoodies, Jacken oder Accessoires suchen, der Einstieg mit einem Kategoriefilter spart Zeit. Jede Kategorie im CSSBuy Spreadsheet enthält relevante Artikel zusammengefasst, was den Vergleich ähnlicher Produkte und die Identifizierung der besten Optionen für Ihre Bedürfnisse erleichtert.",
      },
      qc: {
        title: "QC-Fotos und Qualitätskontrolle",
        content: "Qualitätskontroll-Fotos (QC) sind essenziell, um den Produktzustand vor dem Versand zu verifizieren. Bei der Recherche über CSSBuy Spreadsheet sollten Sie immer prüfen, ob QC-Fotos für Artikel verfügbar sind, die Sie interessieren. Prüfen Sie die Bilder sorgfältig auf Nahtqualität, Materialbeschaffenheit, Farbgenauigkeit und sichtbare Mängel. Falls etwas von der Produktbeschreibung abweicht, bitten Sie um Klärung, bevor Sie Ihre Bestellung bestätigen.",
      },
      shipping: {
        title: "Versand- und Lagerüberlegungen",
        content: "Versandkosten hängen von Gewicht, Abmessungen, Zielort und Versandlinie ab. Bevor Sie einen Kauf abschließen, schätzen Sie die Versandkosten mit verfügbaren Rechnern und prüfen Sie Konsolidierungsoptionen im Lager. Die Zusammenfassung mehrerer Artikel in einer Sendung kann Gesamtkosten reduzieren. Prüfen Sie immer die Lageraufbewahrungspolitik, um zu verstehen, wie lange Artikel vor dem Versand gelagert werden können.",
      },
      safety: {
        title: "Sicherheitscheckliste vor dem Kauf",
        content: "Bevor Sie einen Kauf abschließen, verifizieren Sie den Verkäuferlink, prüfen aktuelle Preise, bestätigen Sie die Verfügbarkeit, überprüfen Sie Größentabellen, begutachten Sie QC-Fotos, verstehen Sie Versandbeschränkungen und bestätigen Sie die endgültigen Gesamtkosten inklusive Versand und anfallender Gebühren. Teilen Sie niemals Ihr Account-Passwort und verwenden Sie immer sichere Zahlungsmethoden.",
      },
      conclusion: {
        title: "Fazit",
        content: "CSSBuy Spreadsheet ist ein wertvoller Ausgangspunkt zur Organisation der Produktrecherche, sollte aber als Referenzwerkzeug und nicht als Garantie für Qualität oder Authentizität verwendet werden. Verifizieren Sie aktuelle Informationen immer direkt auf der Plattform, bevor Sie kaufen. Indem Sie den Recherche- und Sicherheitspraktiken in diesem Leitfaden folgen, können Sie fundiertere Entscheidungen treffen und das Risiko unerwarteter Probleme reduzieren.",
      },
    },
    cta: "Recherche auf der Hauptseite fortsetzen",
  },
};